import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

// import XLSX from 'xlsx';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';

import mainNC from '../functions/notas/mainnc';
import hacerRX from '../functions/hacerrx';

// "use strict";

//Notas Crédito
const DetNC = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.observacNota}</td>
      <td className='right aligned'>{general.formatNum(elemento.valor.toString())}</td>
    </tr>
  )
};

const ListaNC = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetNC elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmNC extends React.Component {
  state={listNC: [], totNC: 0,
        permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  nextVal = async (name) => {
    const argsUpd = {
        coleccion: name,
      }
      const response = await this.props.editSeqfindOneAndUpdate({
        variables: argsUpd
      });
      return response.data.editSeqfindOneAndUpdate.seq
  }

  handleChange = async (ev) => {
// console.log(ev.target.name)

    const updState = (listNC, totNC) => {
      this.setState({listNC, totNC, errors: []})
    };

    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let archcsv = ""
// console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numAj = 0, linea = 0, listNC = [], totNC = 0
          lines.forEach(line => {
            if(line&&(numAj>0||(numAj===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let contrato = campos[0]
              let observacNota = campos[1]
              let valor = parseInt(campos[2], 10)
              totNC += valor
              listNC.push({linea, contrato, observacNota, valor})
            }
            numAj += 1
          })
          updState(listNC, totNC)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listNC: [], totNC: 0, errors: []})
      }
    }
  }

  handleSubmit = async (ev, listNC, valorparaPermRX)=>{
    let errors = []
    if(listNC.length===0){
      errors.push({path: "Notas Crédito", message: "No hay notas crédito"});
    }
    for(let ii=0; ii<listNC.length; ii++){
      let elemento = listNC[ii]
      if(!elemento.contrato||!elemento.observacNota||!elemento.valor){
        errors.push({path: "Notas Crédito", message: `Datos inválidos en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}, Observación: ${elemento.observacNota}, Valor: ${elemento.valor}`});
      }
      
      if(this.props.allClientes.allClientes){
        let {data} = await this.props.allClientes.refetch({contrato: listNC[ii].contrato, numDocum: 1327})
        let allClientes = await data.allClientes
        if(allClientes.length===0){
          errors.push({path: "Clientes", message: `Contrato NO existe en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
        }
      }

      if(elemento.valor<=0){
        errors.push({path: 'Valor', message: `Línea No. ${elemento.linea} => El valor de la nota crédito ($${elemento.valor}) no puede ser menor o igual a cero`});
      }
    }

    this.setState({errors})
    if(errors.length===0){
//PROCESO APLICAR NOTAS CREDITO
      document.body.style.cursor = 'wait'

//EL ULTIMO CONTRATO NO DEBE TENER NAS DE UNA NOTA CREDITO PORQUE SI TIENE MAS DE UNA,
//CUANDO ENCUENTRE LA PRIMER NOTA CREDITO Y LA COMPARE CON contratoFinProc FINALIZA EL PROCESO
      let iii = 0, contratoFinProc = listNC[listNC.length-1].contrato, contratoFin = ""

      const startTime = async (listNC, allCli, allMovCli, editSeqfindOneAndUpdate, createNotasDebCre,
          editNotasDebCreUpdDoc, allFactRG, createHistClienteMany, createMovClientes, editMovClientes,
          createMovCliCCMany, editCliente, allMovCliCC, allProcF, editClienteMany, editClienteUpdDocMany,
          createMovClientesMany) => {
        let clienteSel = {}, lista4 = [], listaFra = []

        setTimeout(async ()=>{
          // console.log("paso NC")
          if(iii<listNC.length){
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha

            if(allCli){
              let {data} = await allCli.refetch({contrato: listNC[iii].contrato, numDocum: 1327})
              let allClientes = await data.allClientes
              clienteSel = allClientes[0]
            }
            if(allMovCli){
              if(clienteSel.saldoPendiente<listNC[iii].valor){
                //Cuando el valor de la nota es mayor que el saldo pendiente => tener en cuenta mov de facturas pagadas
                let {data} = await allMovCli.refetch({contrato: listNC[iii].contrato, orden: '-_id'})
                let allMovClientes = await data.allMovClientes
                lista4 = allMovClientes

                let lista4_1 = [], lista4_2 = []
                lista4_2 = lista4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
                lista4_1 = lista4.filter(elemento => elemento.tipo==="C" &&
                  elemento.subTipo==="CF" && elemento.valorTotal===elemento.valorPagado)          
                lista4_1 = lista4_2.concat(lista4_1);
                lista4 = lista4_1
              }else{
                let {data} = await allMovCli.refetch({contrato: listNC[iii].contrato, orden: '+_id'})
                let allMovClientes = await data.allMovClientes
                lista4 = allMovClientes
                lista4 = lista4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
              }            
            }
            let listFactDetN = []
            //debe tener saldo pendiente >= al valor de la nota
            // if(lista4.length>0 && clienteSel.saldoPendiente >= listNC[iii].valor){
            if(lista4.length>0){
              let valorSaldoConFra = 0
              let lista4ConFra = []
              for(let i=0; i<lista4.length; i++){
                if(lista4[i].numeroFra){
                  valorSaldoConFra += lista4[i].valorTotal
                  lista4ConFra.push({numeroFra: lista4[i].numeroFra})
                }
              }
              lista4ConFra = _.uniqWith(lista4ConFra, _.isEqual);
              //El valor pendiente con saldo por factura (valorSaldoConFra) debe ser >= que el valor de la nota
              let valorNota = listNC[iii].valor
              let listaFra = []
              // console.log(lista4ConFra.length, lista4ConFra)
              if(lista4ConFra.length>0 && valorSaldoConFra >= valorNota){
                for(let i=0; i<lista4ConFra.length; i++){
                  let argsBuscarFactUsu = {}
                  argsBuscarFactUsu = {tipoqry: `[{$match: {'numeroFra': '${lista4ConFra[i].numeroFra}'}},
                  {"$unwind": '$detalleFact'},
                  {$project: {'numeroFra': 1, idRangoFact: 1, valorNC: 1,
                      'descrClaseServ': '$detalleFact.descrClaseServ',
                      'codigoServicio': '$detalleFact.codigoServicio',
                      'descripcionServicio': '$detalleFact.descripcionServicio',
                      'nombreResumido': '$detalleFact.nombreResumido',
                      'periodo': '$detalleFact.periodo',
                      'consecEnFra': '$detalleFact.consecEnFra',
                      'valorSF': {
                          $let: {
                              vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                              in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                          }
                      },
                      'valorIF': {
                          $let: {
                              vars: {valorTipo: '$detalleFact.valor', tipo: '$detalleFact.tipo'},
                              in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                          }
                      }
                    }
                  },
                  {$group: {_id: {numeroFra: '$numeroFra', idRangoFact: '$idRangoFact', valorNC: '$valorNC',
                      descrClaseServ: '$descrClaseServ',
                      'codigoServicio': '$codigoServicio', descripcionServicio: '$descripcionServicio',
                      nombreResumido: '$nombreResumido', periodo: '$periodo', 'consecEnFra': '$consecEnFra'},
                      valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
                  {$unwind: "$_id"},
                      {$project: {_id: 0, 'numeroFra': '$_id.numeroFra', 'concepto': '$_id.idRangoFact',
                      'valorNC': '$_id.valorNC',
                      'descrClaseServ': '$_id.descrClaseServ',
                      'descripcionServicio': '$_id.descripcionServicio',
                      'tipoGen': '$_id.codigoServicio',
                      'codProcFact': '$_id.nombreResumido',
                      'descrRecurso': '$_id.periodo',
                      'totServ': '$_id.consecEnFra',                  
                      'totFras': {
                          $let: {
                              vars: {valorSF: '$valorSF', valorIF: '$valorIF'},
                              in: { $cond: { if: { $gt: [ "$$valorIF", 0 ] },
                                then: {$divide: [ { $multiply: [ "$$valorIF", 100 ] }, "$$valorSF" ]},
                                else: 0 } }
                          }
                      },
                      valorSF: {$toInt: '$valorSF'}, valorIF: {$toInt: '$valorIF'}}}
                    ]`
                  }
                  // console.time(1)
                  let {data} = await allFactRG.refetch(argsBuscarFactUsu)
                  let allFactRtesGroup = await data.allFactRtesGroup
                  listaFra = listaFra.concat(allFactRtesGroup);
                  // console.timeEnd(1)
                }
                // console.log(listaFra)
                //calcular el valor total de las fact al que se le puede hacer NC
                let valorSaldoNCFra = 0
                listaFra.forEach((elemento, i) => {
                  valorSaldoNCFra += (elemento.valorSF + elemento.valorIF)
                })
                for(let i=0; i<lista4ConFra.length; i++){
                  let indexFrado = listaFra.findIndex(elemento => elemento.numeroFra===lista4ConFra[i].numeroFra)
                  if(indexFrado!==-1){
                    valorSaldoNCFra -= listaFra[indexFrado].valorNC
                  }else{
                    valorSaldoNCFra = 0
                  }
                }
                if(lista4ConFra.length===0){
                  valorSaldoNCFra = 0
                }
                //FIN calcular el valor total de las fact al que se le puede hacer NC

                // OJOOO las siguientes dos lineas solo para notas de conectic A
                // valorSaldoNCFra = valorNota
                // lista4ConFra = listaFra

                // console.log(listNC[iii].contrato, listaFra, valorSaldoNCFra, valorNota)
                if(listaFra.length>0 && valorSaldoNCFra >= valorNota){
                  // const elemento3 = listaFra
                  listaFra.forEach((elemento, i) => {
                    listFactDetN.push({numeroFra: elemento.numeroFra, idRangoFact: elemento.concepto, valorNC: elemento.valorNC,
                      codigoServicio: elemento.tipoGen,descrClaseServ: elemento.descrClaseServ,
                      nombreResumido: elemento.codProcFact, descripcionServicio: elemento.descripcionServicio,
                      periodo: elemento.descrRecurso, consecEnFra: elemento.totServ, porcImpto: Math.round(elemento.totFras),
                      valorSF: elemento.valorSF, valorIF: elemento.valorIF, nuevoValor: elemento.valorSF + elemento.valorIF,
                      _id: i, estadoSelecc: true
                    });
                  })
                  // console.time(2)
                  // console.log(listFactDetN)
                  let contratoNC = await mainNC(listNC[iii], clienteSel, lista4, lista4ConFra, listFactDetN, editSeqfindOneAndUpdate,
                    createNotasDebCre, editNotasDebCreUpdDoc, createHistClienteMany, createMovClientes,
                    editMovClientes, editCliente, fechaHoraHoy, valorparaPermRX)
                  // console.timeEnd(2)
                  contratoFin = contratoNC.contrato

                  if(contratoNC.hacerRX){
                    let clase = "Nota crédito"
                    let numeroMov = contratoNC.numeroNota

                    let lista8CC = []
                    if(allMovCliCC){
                      let argsBuscarMC={}
                      argsBuscarMC.orden='+_id'
                      if(listNC[iii].contrato){
                        argsBuscarMC.contrato=listNC[iii].contrato
                      }else{
                        argsBuscarMC.contrato=null
                      }
                      let {data} = await allMovCliCC.refetch(argsBuscarMC)
                      if(data!==undefined){
                        lista8CC = await data.allMovClientesCC
                      }
                    }
                    let ultPF = []
                    if(allProcF){
                      ultPF = allProcF.allProcFact.filter(elemento => elemento.cicloFact===clienteSel.cicloFact)
                    }
            
                    let hacerlarx = await hacerRX(numeroMov, listNC[iii], clienteSel, lista4, lista8CC,
                      createHistClienteMany, createMovClientesMany, createMovCliCCMany,
                      editClienteMany, editClienteUpdDocMany, editMovClientes, editCliente, ultPF, clase, fechaHoraHoy)
                  }
                }else{
                  if(listaFra.length>0 && valorSaldoNCFra >= valorNota){
                    errors.push({path: iii + " Contrato: " + listNC[iii].contrato, message: "No hay facturas con saldo pendiente para hacerle Notas Crédito"});
                  }else{
                    errors.push({path: iii + " Contrato: " + listNC[iii].contrato, message: "El valor de la Nota Crédito es mayor al valor disponible en las facturas para hacer Notas Crédito"});
                  }
                  // console.log("NO NC => NO Existe Fra o Valor de NC pendiente con factura en fact es < al valor de la nota", listNC[iii].contrato, clienteSel.saldoPendiente, listNC[iii].valor)
                }
              }else{
                errors.push({path: iii + " Contrato: " + listNC[iii].contrato, message: "El valor de la Nota Crédito es mayor al valor de las facturas pendientes por pagar"});
                // console.log("NO NC => El valor pendiente con factura en movcli es < al valor de la nota", listNC[iii].contrato, clienteSel.saldoPendiente, listNC[iii].valor, valorSaldoConFra)
              }
            }else{
              errors.push({path: iii + " Contrato: " + listNC[iii].contrato, message: "El valor de la Nota Crédito es mayor al saldo pendiente"});
              // console.log("NO NC => Saldo < valor nota", listNC[iii].contrato, clienteSel.saldoPendiente, listNC[iii].valor)
            }

            await startTime(listNC, allCli, allMovCli, editSeqfindOneAndUpdate, createNotasDebCre,
              editNotasDebCreUpdDoc, allFactRG, createHistClienteMany, createMovClientes, editMovClientes,
              createMovCliCCMany, editCliente, allMovCliCC, allProcF, editClienteMany, editClienteUpdDocMany,
              createMovClientesMany)
            // console.log(iii, "contrato ", contratoFin, contratoFinProc)
            if(contratoFin===contratoFinProc || iii === listNC.length - 1){
              setTimeout(async () => {
                this.setState({listNC: [], totNC: 0})
                document.body.style.cursor = 'default'
              }, 600)

              // console.log("timeout fin", iii)
            }

            iii += 1
          } 
        }, 200);
      }
      await startTime(listNC, this.props.allClientes, this.props.allMovClientes,
                      this.props.editSeqfindOneAndUpdate, this.props.createNotasDebCre,
                      this.props.editNotasDebCreUpdDoc, this.props.allFactRtesGroup,
                      this.props.createHistClienteMany, this.props.createMovClientes,
                      this.props.editMovClientes,
                      this.props.createMovCliCCMany, this.props.editCliente,
                      this.props.allMovClientesCC, this.props.allProcFact,
                      this.props.editClienteMany, this.props.editClienteUpdDocMany, this.props.createMovClientesMany)
    }

    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {listNC, totNC, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let mensaje = "APLICAR NOTAS CREDITO"
    let imgIcon = "images/archivo_32.png"

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listNC, this.props.empresa.valorparaPermRX):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Procesar archivo de notas crédito</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>

                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Notas Crédito:&nbsp;
                  {listNC.length}&nbsp;&nbsp;&nbsp;&nbsp;
                  Valor:&nbsp;
                  ${general.formatNum(totNC.toString())}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="No se crearon las siguientes Notas Crédito:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

                <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                    <th className=''>No.</th>  
                    <th className=''>Contrato</th>
                    <th className=''>Observaciones</th>
                    <th className='right aligned'>$ Valor</th>
                    </tr>
                  </thead>
                  <ListaNC list={listNC}/>
                </table>
              </div>

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "ABCXYZ", orden: '+_id'}}}}),

  graphql(queries.query.allMovClientesCC, {name:'allMovClientesCC', options: (props) => {return {variables: {orden: '-_id'}}}}),
  graphql(queries.query.allProcFact, {name:'allProcFact', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.createNotasDebCre, {name:'createNotasDebCre'}),
  graphql(queries.mutation.editNotasDebCreUpdDoc, {name:'editNotasDebCreUpdDoc'}),
  graphql(queries.query.allFactRtesGroup, {name:'allFactRtesGroup', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: '123XYZ'}}]`}}}}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),
  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),

  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcAdmNC)
